<template>
  <v-dialog v-model="dialog" max-width="80%" persistent>
      <v-card>
            <v-card-title class="pa-1">
                <v-col cols="12" class="pa-0 text-right">
                    <v-btn icon color="primary" @click="close()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-col>
                <v-col cols="12" class="pa-0 text-center">
                    <h1>Histórico do Recurso</h1>
                </v-col>
            </v-card-title>
            
            <v-card-text class="py-0">
                <v-row>
                    <!-- <v-col cols="4" class="pl-8 pr-0">
                        <b>Operadora:</b>
                        <div>{{historico.prestador_id}}</div>
                    </v-col>
                    <v-col cols="4" class="pl-8 pr-0">
                        <b>Prestador:</b>
                        <div>{{historico.operadora_ans_id}}</div>
                    </v-col>
                    <v-col cols="4" class="pl-8 pr-0">
                        <b>Login:</b>
                        <div>{{historico.logins}}</div>
                    </v-col> -->
                    <v-col cols="12" class="py-1">
                        <v-data-table dense :headers="headers" :items="historico" hide-default-footer>
                            <template v-slot:item.dt_alteracao="{item}">
                                {{item.dt_alteracao | formatDate}}
                            </template>
                            <template v-slot:item.acao="{item}">
                                {{acaoEnum[item.acao]}}
                            </template>
                            <template v-slot:item.alteracao="{item}">
                                 <span class="py-2" v-html="item.alteracao"></span>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions class="justify-center py-5">
                <v-btn
                    color="primary"
                    height="30px"
                    small
                    depressed
                    @click="close()"
                >Fechar
                </v-btn>
            </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment"
export default {
    data() {
        return {
            acaoEnum:{
                updateguia: 'Edição individual',
                updateguias: 'Edição em massa',
                deleteguia: 'Exclusão',
                desfazedicaolote: 'Desfazer edições'
            },
            headers: [
                { text: "Data", value: "dt_alteracao", sortable: false, width: '160px' },
                { text: "Ação", value: "acao", sortable: false },
                { text: "Descrição", value: "alteracao", sortable: false },
                { text: "Usuário", value: "username_alteracao", sortable: false },
            ],
        }
    },
    filters: {
        formatDate(date) {
            return moment(date).format("L [às] HH:mm:ss");
        },
    },
    props: {
        dialog: Boolean,
        close: Function,
        historico: Array
    }
}
</script>

<style>

</style>